<template>
  <ul v-if="list.length" class="column-321">
    <li v-for="item in list" :key="hash(item)" class="mt-5">
      <TheNuxtLink
        v-if="item.link !== null"
        :to="item.link.url"
        :title="item.name"
        class="block text-sm font-bold leading-6 hover:text-blue-400"
      >
        {{ item.name }}
        <TheBadge v-if="item.isHot" name="HOT" theme="red" class="ml-1" />
        <TheBadge v-if="item.isNew" name="NEW" theme="orange" class="ml-1" />
        <TheBadge v-if="item.isSuite" name="SUITE" theme="blue" class="ml-1" />
      </TheNuxtLink>

      <div
        v-if="item.link === null"
        :title="item.name"
        class="text-base font-bold text-gray-600"
      >
        {{ item.name }}
        <TheBadge v-if="item.isHot" name="HOT" theme="red" class="ml-1" />
        <TheBadge v-if="item.isNew" name="NEW" theme="orange" class="ml-1" />
        <TheBadge v-if="item.isSuite" name="SUITE" theme="blue" class="ml-1" />
      </div>

      <p
        v-if="item.shortIntroduction"
        class="break-words pt-1 text-sm text-gray-600"
      >
        {{ item.shortIntroduction }}
      </p>
    </li>
  </ul>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { IFormatMenu } from '@/stores/menuStore';

  interface IProps {
    list: IFormatMenu[];
  }

  withDefaults(defineProps<IProps>(), {
    list: () => [],
  });
</script>
